import { createContext, useContext, useSyncExternalStore } from "react";
import type { AppServices } from "./services";

const ServicesContext = createContext<AppServices | null>(null);

export const ServicesProvider = ServicesContext.Provider;

export function useServices(): AppServices {
  const s = useContext(ServicesContext);
  if (!s) throw new Error("useServices outside ServicesProvider");
  return s;
}

export function useSession() {
  const { session } = useServices();
  const authenticated = useSyncExternalStore(session.subscribe, session.isAuthenticated);
  const user = useSyncExternalStore(session.subscribe, session.getUser);
  return { authenticated, user, session };
}

export function useOnline(): boolean {
  const { online } = useServices();
  return useSyncExternalStore(online.subscribe, online.isOnline);
}

export function useLastUpdated(): number | null {
  const { freshness } = useServices();
  return useSyncExternalStore(freshness.subscribe, freshness.lastUpdated);
}
